import { render, staticRenderFns } from "./GradeCoachUpContainer.vue?vue&type=template&id=2bcf326a&scoped=true&"
import script from "./GradeCoachUpContainer.vue?vue&type=script&lang=js&"
export * from "./GradeCoachUpContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcf326a",
  null
  
)

export default component.exports